import { Component, type ErrorInfo, type ReactNode } from 'react';
import { clearChunkReloadGuard, recoverFromChunkError } from './AppErrorBoundary';

interface Props {
  children: ReactNode;
  resetKey: string;
}

interface State {
  error: Error | null;
}

export default class RouteErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('Unhandled module error:', error, info);
    recoverFromChunkError(error);
  }

  componentDidUpdate(previousProps: Props) {
    if (this.state.error && previousProps.resetKey !== this.props.resetKey) {
      this.setState({ error: null });
    }
  }

  private retry = () => {
    clearChunkReloadGuard();
    window.location.reload();
  };

  render() {
    if (!this.state.error) return this.props.children;

    return (
      <section className="m-6 rounded-xl border border-red-200 bg-white p-6 shadow-sm">
        <h1 className="text-lg font-semibold text-slate-900">No se pudo mostrar este modulo</h1>
        <p className="mt-2 text-sm text-slate-600">
          La aplicacion sigue funcionando. Recarga para obtener la version mas reciente del modulo.
        </p>
        <button
          type="button"
          onClick={this.retry}
          className="mt-5 rounded-lg bg-[#0F5132] px-4 py-2.5 text-sm font-medium text-white hover:bg-[#0A3D26]"
        >
          Recargar modulo
        </button>
      </section>
    );
  }
}
